import millify from "millify";
import React from "react";
import InfoIcon from "../../../assets/svgs/common/info.svg";
import type { ICampaignMetricMinimal } from "../../../types/models/campaign-metric.types";

interface AppProps {
  campaignMetrics: ICampaignMetricMinimal;
}

const StatsHomeDashboardBrandPartial: React.FunctionComponent<AppProps> = ({
  campaignMetrics,
}) => {
  const [data] = React.useState([
    {
      title: "Overall views",
      value: millify(campaignMetrics.totalViews ?? 0),
    },
    {
      title: "Cost per view",
      value: campaignMetrics.costPerView?.toFixed(3) ?? "0.000",
    },

    {
      title: "Overall posts",
      value: millify(campaignMetrics.totalPosts ?? 0),
    },
  ]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-10 w-full">
      {data.map((item) => {
        return (
          <div
            key={item.title}
            className="flex flex-col flex-1 bg-statcardbg px-6 py-8 border border-border rounded-10 min-w-0"
          >
            <p className="flex items-center gap-2 font-semibold text-base text-secondary">
              {item.title} <InfoIcon />
            </p>
            <p className="font-black text-3xl text-primary break-words">{item.value}</p>
          </div>
        );
      })}
    </div>
  );
};

export default StatsHomeDashboardBrandPartial;
